import { Form, Spin } from 'antd'
import Button from 'components/Button'
import Control from 'components/Control/Control'
import AddIcon from 'components/icons/AddIcon'
import { setResumeData } from '../../../../../OnBoarding/actions'
import { v4 as uuidv4 } from 'uuid'
import instituteRequest from '../../../../../../utils/instituteRequest'
import {
  AdjustIcon,
  FooterFlex,
  LocalDiv,
  OptionWrapper,
  SelectLocalWrapper,
  StyledDrawer,
  Text,
} from '../DrawerStyle'
import EducationForm from './EducationFormPartial'
import { educationDetails } from './constant'
import moment from 'moment'
import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import ErrorMessage from 'utils/ErrorMessage'
import SuccessMessage from 'utils/SuccessMessage'
import { searchConfig } from 'utils/config'
import { updateCurrentState } from '../../../../../OnBoarding/actions'
import { getStudentDataById } from '../../../../actions'
import UpdatePopup from '../../UpdatePopup'
import SuccessPopupModal from '../../SuccessPopup'
import {
  educationDetailsBefore,
} from './educationNewConstant'

//import { getCollege } from '../../actions'
const EducationalDetailDrawer = ({
  drawerStatus,
  setdrawerStatus,
  studentFormData,
  pendingData,
  updateStudentData,
  getPendingData,
  instituteName,
  deleteEducation,
  deleteFile,
  countryList,
  stateList,
  getListOfCountries,
  getListOfCity,
  getListOfState,
  getListOfSkills,
  degreeList,
  listOfStudentSkills,
  searchAPI,
  studentId,
}) => {
  console.log("PendingData", pendingData)
  const [form] = Form.useForm()
  const dispatch = useDispatch()
  const [refreshKey, setRefreshKey] = useState(1)
  const { Option } = SelectLocalWrapper
  const [education, setEducation] = useState([])
  const [updatedList, setUpdatedList] = useState([])
  const [updated, setUpdated] = useState(false)
  const [stateId, setStateId] = useState('')
  const [cityId, setCityId] = useState('')
  const [showUpdatePopup, setShowUpdatePopup] = useState(false)
  const [succesPopup, setSuccessPopup] = useState(false)
  const [locationData, setLocationData] = useState({
    stateId: '',
    state: '',
    cityId: '',
    city: '',
  })
  const [universityName, setUniversityName] = useState('')
  const [universitySearchList, setUniversitySearchList] = useState([])
  const [loading, setLoading] = useState(true)
  const [submitLoading, setSubmitLoading] = useState(false)
  const [loadingState, setLoadingState] = useState(false)
  const [loadingCity, setLoadingCity] = useState(false)
  const [isUpdateButtonEnabled, setIsUpdateButtonEnabled] = useState(true)
  const [educationList, setEducationList] = useState([])
  const [countryId, setCountryId] = useState('')
  const [examType, setExamType] = useState('')
  const [duration, setDuration] = useState('')
  const [instituteCampusName, setInstituteCampusName] = useState('')
  const [universityId, setUniversityId] = useState('')
  const [instituteId, setInstituteId] = useState('')
  const [currentInstituteId, setCurrentInstituteId] = useState(
    studentFormData?.student?.instituteCampusId
      ? studentFormData?.student?.instituteCampusId
      : null
  )
  const [currentInstituteName, setCurrentInstituteName] = useState(
    studentFormData?.student?.instituteCampusName
      ? studentFormData?.student?.instituteCampusName
      : null
  )
  const [searchCollege, setSearchCollege] = useState('')
  const [skillLoading, setSkillLoading] = useState(false)
  const [listOfSkills, setListOfSkills] = useState([])
  const [shown, setShown] = useState([])
  const [allSkills, setAllSkills] = useState([])
  const [tpoConfig, setTpoConfig] = useState(null)
  const [frozenFieldsMap, setFrozenFieldsMap] = useState({})
  const [isAddNewFrozen, setIsAddNewFrozen] = useState(false)

  const hasPendingEducation = pendingData?.data?.education?.length > 0 ||
    (pendingData?.data?.currentCourse && Object.keys(pendingData.data.currentCourse).length > 0)

  const getEducationLevelLabel = level => {
    switch (level) {
      case 'tenth':
        return '10th'
      case 'twelfth':
        return '12th'
      case 'puc':
        return 'Diploma'
      case 'p_g_diploma':
        return 'PG DIPLOMA'
      case 'diploma':
        return 'Diploma'
      case 'ug':
        return 'UG'
      case 'pg':
        return 'PG '
      case 'phd':
        return 'PD'
      case 'pd':
        return 'PD'
      default:
        break
    }
  }
  const [listOfAddedSkills, setListOfAddedSkills] = useState([])

  const SkillsAPI = async search => {
    try {
      const results = await searchAPI(
        searchConfig?.skills?.name,
        search,
        searchConfig?.skills
      )
      let updatedSkills = results || []
      const newSkill = {
        name: search,
        id: Math.random().toString(36).substr(2, 8),
      }
      if (updatedSkills.length === 0 && search) {
        setListOfAddedSkills(prev => [...prev, newSkill])
        updatedSkills = [newSkill, ...updatedSkills]
      }

      const isExactMatch = updatedSkills.some(
        skill => skill?.name.toLowerCase() === search?.toLowerCase()
      )
      if (updatedSkills.length > 0) {
        if (!isExactMatch && search?.length > 3) {
          setListOfAddedSkills(prev => [...prev, newSkill])
          updatedSkills = [newSkill, ...updatedSkills]
        } else {
          updatedSkills = updatedSkills
        }
      }

      if (!allSkills?.length) {
        setAllSkills(updatedSkills)
      }
      setSkillLoading(false)
      return updatedSkills
    } catch (error) {
      setSkillLoading(false)

      console.error(`Error searching ${searchConfig?.skills?.name}:`, error)
    }
  }

  useEffect(() => {
    const fetchData = async () => {
      try {
        setSkillLoading(true)
        await SkillsAPI('')
      } finally {
        setSkillLoading(false)
      }
    }

    fetchData()
  }, [])
  useEffect(() => {
    getListOfState('', '', false, setLoadingState)

    searchAPI(
      searchConfig?.universities?.name,
      '',
      searchConfig?.universities
    )

      .then(results => setUniversitySearchList(results))
      .catch(error =>
        console.error(
          `Error searching ${searchConfig?.universities?.name}:`,
          error
        )
      )
  }, [])

  useEffect(() => {
    const fetchTpoConfig = async () => {
      try {
        const instituteCampusId = studentFormData?.student?.instituteCampusId
        if (instituteCampusId) {
          const response = await instituteRequest.get(
            `/institutes/${instituteCampusId}/tpo-approval-config`
          )
          if (response?.data?.data) {
            setTpoConfig(response.data.data)
          }
        }
      } catch (error) {
        console.error('Error fetching TPO config:', error)
      }
    }
    fetchTpoConfig()
  }, [studentFormData?.student?.instituteCampusId])

  useEffect(() => {
    if (!tpoConfig || !tpoConfig.tpoApprovalConfig || !tpoConfig.tpoApprovalConfig.fields) {
      setFrozenFieldsMap({})
      setIsAddNewFrozen(false)
      return
    }

    const frozen = {}
    const educationData = studentFormData?.educationProfile || []
    const fields = tpoConfig.tpoApprovalConfig.fields

    const addNewConfig = fields['education.addNew']
    const hasApprovedEducation = educationData.length > 0
    setIsAddNewFrozen(addNewConfig?.freezeAfterVerification && hasApprovedEducation)

    educationData.forEach((edu) => {
      if (!edu.id) return

      const eduId = edu.id
      frozen[eduId] = {}

      let fieldPrefix = ''
      const level = edu.educationLevel?.toLowerCase()

      if (level === 'tenth' || level === 'hsc') {
        fieldPrefix = 'tenth'
      } else if (level === 'twelfth' || level === 'sslc' || level === 'puc') {
        fieldPrefix = 'twelfth'
      } else if (level === 'ug' || level === 'pg' || level === 'diploma' || level === 'p_g_diploma' || level === 'phd' || level === 'pd') {
        const isCurrentCourse = studentFormData?.student?.currentCourse?.id === edu.id
        fieldPrefix = isCurrentCourse ? 'currentCourse' : 'otherEducation'
      }

      if (!fieldPrefix) return

      let eduFields = []
      if (fieldPrefix === 'tenth' || fieldPrefix === 'twelfth') {
        eduFields = ['board', 'endYear', 'marks', 'certifications']
      } else {
        eduFields = ['state', 'city', 'collegeName', 'university', 'degree', 'department', 'specialisation', 'endYear', 'marks', 'certifications']
        if (fieldPrefix === 'currentCourse') {
          eduFields.push('noOfArrears')
        }
      }

      eduFields.forEach((field) => {
        const fullFieldName = `${fieldPrefix}.${field}`
        const fieldConfig = fields[fullFieldName]

        if (fieldConfig && fieldConfig.freezeAfterVerification) {
          const fieldValue = edu[field]
          const hasValue = fieldValue !== null && fieldValue !== undefined && fieldValue !== '' &&
            (!Array.isArray(fieldValue) || fieldValue.length > 0)

          if (hasValue) {
            frozen[eduId][field] = true
          }
        }
      })
    })

    setFrozenFieldsMap(frozen)
  }, [tpoConfig, studentFormData?.educationProfile, studentFormData?.student?.currentCourse])

  useEffect(() => {
    setLoading(true)
    let educationsdataList = []
    let tenth = false
    let twelfth = false

    educationList?.forEach(data => {
      let educationLevel = data.educationLevel?.toLowerCase()
      // Don't modify educationLevel - keep original values for API compatibility
      if (educationLevel === 'tenth' || educationLevel === 'hsc') {
        tenth = true
      }
      if (
        educationLevel === 'twelfth' ||
        educationLevel === 'sslc' ||
        educationLevel === 'diploma' ||
        educationLevel === 'puc'
      ) {
        twelfth = true
      }
    })

    if (!tenth) {
      educationsdataList.push({
        component: EducationForm,
        level: 'tenth',
        label: '10th',
        type: true,
      })
    }
    // Note: 12th/Diploma form is NOT auto-added - user must add it via the "12th or Diploma" button
    educationList?.map(data => {
      let type =
        data?.educationLevel === 'tenth' || data?.educationLevel === 'twelfth'
      let level = getEducationLevelValue(
        data?.educationLevel,
        true,
        educationsdataList
      )
      form.setFieldsValue({
        [level]: {
          id: data?.id,
          temp_id: data?.temp_id,
          educationLevel: level,
          university: data?.university,
          universityId: data?.universityId,
          institutionName: data?.institutionName,
          collegeName: data?.collegeName,
          institutionId: data?.institutionId,
          collegeId: data?.collegeId,
          board: data?.board,
          degree: data?.degree,
          department: data?.department,
          specialisation: data?.specialisation,
          degreeStreamMapId: data?.degreeStreamMapId,
          degreeId: data?.degreeId,
          specialisationId: data?.specialisationId,
          specialisationValue: (() => {
            // Split specialisationId and specialisation strings into arrays
            const ids = data?.specialisationId ? (Array.isArray(data?.specialisationId) ? data?.specialisationId : String(data?.specialisationId).split(',')) : [];
            const names = data?.specialisation ? String(data?.specialisation).split(',') : [];

            // Create array of objects with id and name properties
            return ids.map((id, index) => ({
              id: id,
              name: names[index] || ''
            })).filter(item => item.id);
          })(),
          streamId: data?.streamId,
          startedOn:
            data?.startedOn > 0
              ? moment(parseInt(data?.startedOn)).format('MM/YYYY')
              : null,
          endedOn:
            data?.endedOn > 0
              ? moment(parseInt(data?.endedOn)).format('MM/YYYY')
              : null,
          endedYear:
            data?.endYear > 0
              ? moment(parseInt(data?.endYear)).format('YYYY')
              : data?.endedOn > 0
                ? moment(parseInt(data?.endedOn)).format('YYYY')
                : null,
          marks: data?.marks ? parseFloat(data?.marks).toFixed(2) : null,
          averageMarks: data?.averageMarks ? parseFloat(data?.averageMarks).toFixed(2) : null,
          noOfArrears: data?.noOfArrears,
          historyOfArrears: data?.historyOfArrears,
          state: data?.state,
          stateId: data?.stateId,
          city: data?.city,
          cityId: data?.cityId,
          tcUrl: data?.tcUrl,
          markSheetUrl: data?.markSheetUrl,
          awards: data?.awards,
          skills: data?.skills,
          domain: data?.domain,
          domainId: data?.domainId,
          isDelete: false,
          shown: true,
        },
      })
      return educationsdataList.push({
        id: data?.id,
        component: EducationForm,
        level: level,
        label: getEducationLevelLabel(data?.educationLevel),
        type: type,
        isCurrentCourse: !!data?.isCurrentCourse,
        markSheetUrl: data?.markSheetUrl,
      })
    })

    setEducation(educationsdataList)
    setUpdatedList(educationsdataList)

    setTimeout(() => {
      setLoading(false)
    }, 500)
  }, [educationList])

  const universityList = useSelector(
    state => state?.studentData?.universityList
  )
  const AllCollegeList = useSelector(state => state?.resumeData?.AllCollegeList)
  const CollegeList = useSelector(state => state?.resumeData?.CollegeList)

  const subjectHandler = (educationLevel, option) => {
    setIsUpdateButtonEnabled(false)
    setRefreshKey(refreshKey + 1)
    let arr = []
    let type = option?.value === 'tenth' || option?.value === 'twelfth'
    arr.push({
      component: EducationForm,
      level: option?.value,
      label: option?.label,
      type: type,
    })
    let levelsList = education?.map(data => data?.level)

    // Check if the selected option is already in the education list
    if (levelsList.includes(option?.value)) {
      // If it's already added, don't add it again
      return
    }

    if (educationLevel !== true && !levelsList.includes(educationLevel)) {
      setUpdatedList(edu => edu.concat(arr))
      return setEducation(edu => edu.concat(arr))
    }
  }

  const getEducationLevelValue = (value, isUpdate = false, educationsList) => {
    if (
      value === 'diploma' ||
      value === 'p_g_diploma' ||
      value === 'ug' ||
      value === 'pg' ||
      value === 'phd'
    ) {
      let list = (isUpdate ? educationsList : education)?.filter(data =>
        data?.level?.includes(value)
      )
      if (value === 'ug') {
        return 'ug' + '_' + list?.length
      } else if (value === 'diploma') {
        return 'diploma' + '_' + list?.length
      } else if (value === 'pg') {
        return 'pg' + '_' + list?.length
      } else if (value === 'phd') {
        return 'phd' + '_' + list?.length
      } else if (value === 'p_g_diploma') {
        return 'p_g_diploma' + '_' + list?.length
      }
    } else {
      return value
    }
  }

  const getAddedLevel = value => {
    let levelsList = updatedList?.map(data => data?.level)
    if (
      value === 'diploma' ||
      value === 'p_g_diploma' ||
      value === 'ug' ||
      value === 'pg' ||
      value === 'phd'
    ) {
      return true
    } else {
      return levelsList.includes(value)
    }
  }

  const onRemoveEducation = async (deleteLevel, educationId) => {
    setIsUpdateButtonEnabled(false)
    let updatedList = education?.filter(data => data?.level !== deleteLevel)
    if (educationId) {
      SuccessMessage('Deleted successfully!')
      form.setFieldsValue({
        [deleteLevel]: '',
      })
      const newDeleteLevel = deleteLevel + 'deleted'
      form.setFieldsValue({
        [newDeleteLevel]: { id: educationId, isDelete: true },
      })
      setUpdatedList(updatedList)
    } else {
      setUpdatedList(updatedList)
    }
  }
  const uuidRegex =
    /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i
  useEffect(() => {
    let currentCourseData = studentFormData?.currentCourse
    setExamType(currentCourseData?.examType)
    setDuration(currentCourseData?.duration)

    // Get pending currentCourse from new structure
    const pendingCurrentCourse = pendingData?.data?.currentCourse

    let currentCourse = {
      id: currentCourseData?.id,
      isCurrentCourse: true,
      university: currentCourseData?.university,
      universityId: currentCourseData?.universityId,
      educationLevel: currentCourseData?.educationLevel,
      collegeName: studentFormData?.instituteCampusName,
      collegeId: studentFormData?.instituteCampusId,
      board: '',
      degree: currentCourseData?.degree,
      department: currentCourseData?.department,
      specialisation: currentCourseData?.specialisation,
      degreeStreamMapId: currentCourseData?.degreeStreamMapId,
      startedOn: currentCourseData?.startedOn,
      endedOn: currentCourseData?.endedOn,
      skills: currentCourseData?.skills,
      degreeId: currentCourseData?.degreeId,
      streamId: currentCourseData?.streamId,
      specialisationId: currentCourseData?.specialisationId,
      averageMarks: currentCourseData?.averageMarks
        ? currentCourseData?.averageMarks
        : 0,
      marks: currentCourseData?.averageMarks ? currentCourseData?.averageMarks : 0,
      state: currentCourseData?.state || '',
      stateId: currentCourseData?.stateId || '',
      city: currentCourseData?.city || '',
      cityId: currentCourseData?.cityId || '',
      noOfArrears: currentCourseData?.noOfArrears ?? 0,
      historyOfArrears: currentCourseData?.historyOfArrears ?? 0,
      domain: currentCourseData?.domain,
      domainId: currentCourseData?.domainId,
      markSheetUrl: currentCourseData?.markSheetUrl,
    }

    // Merge pending currentCourse fields if available
    if (pendingCurrentCourse && pendingCurrentCourse._pendingFields) {
      const firstFieldKey = Object.keys(pendingCurrentCourse._pendingFields)[0]
      if (firstFieldKey && pendingCurrentCourse._pendingFields[firstFieldKey]._requestId) {
        currentCourse._requestId = pendingCurrentCourse._pendingFields[firstFieldKey]._requestId
      }

      currentCourse._pendingFields = pendingCurrentCourse._pendingFields

      // Apply pending field values
      Object.keys(pendingCurrentCourse._pendingFields).forEach(fieldName => {
        const fieldData = pendingCurrentCourse._pendingFields[fieldName];

        if (fieldData.value !== null && fieldData.value !== undefined) {
          if (fieldName === 'university' && typeof fieldData.value === 'object') {
            currentCourse.university = fieldData.value.university;
            currentCourse.universityId = fieldData.value.universityId;
          } else {
            currentCourse[fieldName] = fieldData.value;
          }
        }
      });

      // Sync marks and averageMarks
      if (pendingCurrentCourse._pendingFields.averageMarks?.value !== null && pendingCurrentCourse._pendingFields.averageMarks?.value !== undefined) {
        currentCourse.marks = pendingCurrentCourse._pendingFields.averageMarks.value
        currentCourse.averageMarks = pendingCurrentCourse._pendingFields.averageMarks.value
      }
    }

    // Get approved education from studentFormData
    const approvedEducation = studentFormData?.educationProfile || studentFormData?.education || []

    // Get pending education from new structure
    const pendingEducation = pendingData?.data?.education || []

    // Merge approved and pending education
    const mergedEducation = approvedEducation.map(approvedEdu => {
      const pendingEdu = pendingEducation.find(p => p.id === approvedEdu.id)

      if (!pendingEdu) {
        return approvedEdu
      }

      const merged = { ...approvedEdu }

      // If pending education has _pendingFields, merge those fields
      if (pendingEdu._pendingFields) {
        merged._pendingFields = pendingEdu._pendingFields
        merged._requestId = Object.values(pendingEdu._pendingFields)[0]?._requestId

        Object.keys(pendingEdu._pendingFields).forEach(fieldName => {
          const fieldData = pendingEdu._pendingFields[fieldName]
          if (fieldData.value !== null && fieldData.value !== undefined) {
            if (fieldName === 'university' && typeof fieldData.value === 'object') {
              merged.university = fieldData.value.university;
              merged.universityId = fieldData.value.universityId;
            } else {
              merged[fieldName] = fieldData.value;
            }
          }
        })
      }

      return merged
    })

    // Add new education items (those with _isNew flag or temp_id)
    const newPendingEducation = pendingEducation.filter(e => e._isNew || e.temp_id)

    const allMergedEducation = [...mergedEducation, ...newPendingEducation]

    if (!studentFormData?.student?.isExpCandidate) {
      let educationList =
        allMergedEducation?.length > 0
          ? [...allMergedEducation, currentCourse]
          : [currentCourse]
      educationList?.sort((a, b) => {
        const endedA = moment(parseInt(a?.endedOn || a?.endYear))
        const endedB = moment(parseInt(b?.endedOn || b?.endYear))

        if (!endedA.isValid() || !endedB.isValid()) {
          return 0
        }

        if (endedB.isAfter(endedA)) return 1
        if (endedA.isAfter(endedB)) return -1
      })
      setEducationList(educationList)
    } else if (studentFormData?.student?.isExpCandidate) {
      let educationList = allMergedEducation
      educationList?.sort((a, b) => {
        const endedA = moment(parseInt(a?.endedOn || a?.endYear))
        const endedB = moment(parseInt(b?.endedOn || b?.endYear))

        if (!endedA.isValid() || !endedB.isValid()) {
          return 0
        }

        if (endedB.isAfter(endedA)) return 1
        if (endedA.isAfter(endedB)) return -1
      })
      setEducationList(educationList)
    }
  }, [studentFormData, instituteName, pendingData])

  const getEducationLevel = level => {
    let name = level?.replaceAll('_', '')
    return name?.replace(/\d/g, '')
  }

  const getEducationLevelSearch = level => {
    let name = level?.replaceAll('_', '')
    let result = name?.replace(/\d/g, '')
    return result === 'pgdiploma'
      ? 'P_G_DIPLOMA'
      : result === 'pd'
        ? 'PHD'
        : result?.toUpperCase()
  }

  const getEducationLevel1 = level => {
    let name = level?.replaceAll('_', '')
    return name === 'pgdiploma'
      ? 'p_g_diploma'
      : name?.replace(/\d/g, '')?.toLowerCase()
  }

  const submitHandler = async () => {
    let values = await form.getFieldValue()
    const errorList = []
    await form
      .validateFields()
      .then(res => {
        setSubmitLoading(true)
      })
      .catch(err => {
        errorList.push(err?.errorFields)
      })
    if (!errorList?.length) {
      let tenth = false
      let twelth = false
      let diploma = false
      let under = false
      let educationList = []
      let educationDeleteList = []
      let currentCourse = []
      const convertedData = Object.keys(values).reduce((acc, key) => {
        if (
          key.includes('ug_') ||
          key.includes('pg_') ||
          key.includes('diploma_') ||
          key.includes('phd_') ||
          key.includes('p_g_diploma')
        ) {
          const [name, award] = key.split('award+')
          const value = values[key]
          if (!acc[name]) {
            acc[name] = {
              ...value,
              awards: [],
            }
          }
          if (key.includes('award+')) acc[name].awards.push({ ...value })
        } else {
          acc[key] = values[key]
        }
        return acc
      }, {})

      // First, check all form values to properly set validation flags
      Object.values(convertedData)?.forEach(data => {
        if (data?.educationLevel && !data?.isDelete) {
          const level = getEducationLevel1(data?.educationLevel)?.toLowerCase()
          if (level === 'tenth') tenth = true
          if (level === 'twelfth' || level === 'sslc') twelth = true
          if (level === 'diploma' || level === 'puc') diploma = true
        }
      })

      // Also check existing education data from studentFormData to ensure we don't miss any
      studentFormData?.education?.forEach(data => {
        const level = data?.educationLevel?.toLowerCase()
        if (level === 'tenth') tenth = true
        if (level === 'twelfth' || level === 'sslc') twelth = true
        if (level === 'diploma' || level === 'puc') diploma = true
      })

      // Check current course education level as well
      if (studentFormData?.currentCourse?.educationLevel) {
        const currentLevel = studentFormData.currentCourse.educationLevel.toLowerCase()
        if (currentLevel === 'diploma' || currentLevel === 'puc') diploma = true
      }

      Object.values(convertedData)?.forEach(data => {
        if (data?.isDelete) {
          educationDeleteList.push(data?.id)
        } else if (data?.noOfArrears >= 0) {

          currentCourse.push({
            ...data,
            averageMarks: data?.marks ? data?.marks : 0,
            endedOn: studentFormData?.currentCourse?.endedOn,
            skills:
              data?.skills?.filter(skill => skill != null).map(skill => ({
                id: /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i.test(
                  skill?.id
                )
                  ? skill.id
                  : '',
                name: skill?.name || '',
              })) || [],
            university: data?.university || null,
            historyOfArrears: data?.historyOfArrears || 0,
            specialisationId: Array.isArray(data?.specialisationId) ? data?.specialisationId.join(',') : data?.specialisationId ?? '',
          })
        } else if (data?.marks && !data?.noOfArrears) {

          const educationItem = {
            ...data,
            temp_id: data?.id ? data?.temp_id : (data?.temp_id || `temp-${uuidv4()}`),
            state: data?.state || '',
            stateId: data?.stateId || '',
            city: data?.city || '',
            cityId: data?.cityId || '',
            educationLevel: getEducationLevel1(data?.educationLevel),
            endedOn: data?.endedYear
              ? moment(data?.endedYear, 'YYYY').format('x')
              : null,
            startedOn: data?.startedYear
              ? moment(data?.startedYear, 'YYYY').format('x')
              : null,
            skills:
              data?.skills?.filter(skill => skill != null).map(skill => ({
                id: /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i.test(
                  skill?.id
                )
                  ? skill.id
                  : '',
                name: skill?.name || '',
              })) || [],
            tcUrl: data?.tcUrl || {},
            markSheetUrl: data?.markSheetUrl || {},
            university: data?.university || null,
            universityId: data?.universityId || '',
            historyOfArrears: data?.historyOfArrears || 0,
            specialisationId: Array.isArray(data?.specialisationId) ? data?.specialisationId.join(',') : data?.specialisationId ?? '',
          }

          educationList.push(educationItem)
        }
      })

      // Check if UG students have either 12th standard OR diploma education
      if (studentFormData?.currentCourse?.educationLevel === 'ug') {
        // Check if 12th standard is being deleted
        const deletingTwelfth = educationDeleteList.some(deleteId => {
          const educationToDelete = studentFormData?.education?.find(edu => edu.id === deleteId);
          return educationToDelete?.educationLevel === 'twelfth';
        });

        // Check if diploma is being deleted
        const deletingDiploma = educationDeleteList.some(deleteId => {
          const educationToDelete = studentFormData?.education?.find(edu => edu.id === deleteId);
          return educationToDelete?.educationLevel === 'diploma' || educationToDelete?.educationLevel === 'puc';
        });

        // Check if user will have either 12th OR diploma after deletion
        const willHaveTwelfth = twelth && !deletingTwelfth;
        const willHaveDiploma = diploma && !deletingDiploma;

        // Error only if BOTH 12th and diploma are missing/deleted
        if (!willHaveTwelfth && !willHaveDiploma) {
          ErrorMessage('UG students must have either 12th standard or Diploma education. At least one is mandatory.');
          setSubmitLoading(false);
          return;
        }
      }

      // Format DOB properly to avoid validation errors
      const formatDOB = (dob) => {
        if (!dob) return undefined
        if (moment(dob, moment.ISO_8601, true).isValid()) {
          return moment(dob).format('YYYY-MM-DD')
        }
        if (moment(dob, 'YYYY-MM-DD', true).isValid()) {
          return dob
        }
        return moment(dob).format('YYYY-MM-DD')
      }

      let payload = {
        refreshRanking: true,
        isDirectTPOUpdate: true,
        checkDeleteSection: ['education'],
        admin: {
          ...studentFormData?.admin,
          dob: formatDOB(studentFormData?.admin?.dob),
          countryCode: studentFormData?.admin?.countryCode,
        },
        student: studentFormData?.student ? {
          ...studentFormData?.student,
          id: studentId,
          instituteCampusId: studentFormData?.student?.instituteCampusId || studentFormData?.admin?.institute_campus_id,
        } : {
          id: studentId,
          instituteCampusId: studentFormData?.admin?.institute_campus_id,
        },
        studentPersonalProfile: studentFormData?.studentPersonalProfile,
        currentCourse: !studentFormData?.student?.isExpCandidate
          ? {
            ...studentFormData?.currentCourse,
            noOfArrears: currentCourse[0]?.noOfArrears,
            specialisationId: currentCourse[0]?.specialisationId,
            specialisation: currentCourse[0]?.specialisation ?? null,
            averageMarks: currentCourse[0]?.averageMarks,
            endedOn: currentCourse[0]?.endedOn,
            skills: currentCourse[0]?.skills,
            university: currentCourse[0]?.university,
            universityId: currentCourse[0]?.universityId,
            historyOfArrears: currentCourse[0]?.historyOfArrears,
            markSheetUrl: currentCourse[0]?.markSheetUrl,
          }
          : {},
        education: (() => {
          const uniqueEducation = []
          const seen = new Set()

          educationList.forEach(edu => {
            const key = JSON.stringify({
              educationLevel: edu.educationLevel,
              degree: edu.degree,
              institutionName: edu.institutionName,
              endedOn: edu.endedOn,
              marks: edu.marks
            })
            if (!seen.has(key)) {
              seen.add(key)
              if (edu.id) {
                const { temp_id, _requestId, _isNew, _status, ...cleanEdu } = edu
                uniqueEducation.push(cleanEdu)
              } else {
                const { _requestId, _isNew, _status, ...cleanEdu } = edu
                uniqueEducation.push(cleanEdu)
              }
            }
          })

          return uniqueEducation
        })(),
        resume: studentFormData?.resume,
        degreeStreamMap:
          !studentFormData?.student?.isExpCandidate &&
            studentFormData?.currentCourse?.degreeId &&
            studentFormData?.currentCourse?.streamId
            ? {
              degreeId: studentFormData?.currentCourse?.degreeId,
              streamId: studentFormData?.currentCourse?.streamId,
            }
            : {},
      }
      delete payload?.currentCourse?.startMonth
      delete payload?.currentCourse?.startYear
      delete payload?.currentCourse?.endMonth
      delete payload?.currentCourse?.endYear

      payload?.education.map((item, index) => {
        delete payload?.education[index]?.startMonth
        delete payload?.education[index]?.startYear
        delete payload?.education[index]?.endMonth
        // delete payload?.education[index]?.endYear

        return null
      })


      if (payload?.currentCourse?.specialisationId === null) {
        //delete payload?.currentCourse?.specialisationId
      }
      if (payload?.studentPersonalProfile?.secondaryEmail === null) {
        delete payload?.studentPersonalProfile?.secondaryEmail
      }
      if (payload?.studentPersonalProfile?.secondaryEmail === '') {
        delete payload?.studentPersonalProfile?.secondaryEmail
      }
      if (payload?.studentPersonalProfile?.registraionNo) {
        delete payload?.studentPersonalProfile?.registraionNo
      }
      if (payload?.currentCourse?.degreeStreamMapId === null) {
        delete payload?.currentCourse?.degreeStreamMapId
      }

      payload?.education.map((item, index) => {
        if (item?.skills === null) delete payload?.education[index]?.skills
        if (item?.degreeStreamMapId === null)
          delete payload?.education[index]?.degreeStreamMapId
        return null
      })

      // Additional validation check for current course
      currentCourse?.forEach((value) => {
        const level = value?.educationLevel?.toLowerCase()
        if (level === 'diploma' || level === 'puc') {
          diploma = true
        }
        if (level === 'ug') {
          under = true
        }
      })
      if (!payload?.currentCourse?.noOfArrears) {
        payload.currentCourse.noOfArrears = 0
      }
      if (payload?.currentCourse?.degreeStreamMapId === null) {
        delete payload?.currentCourse?.degreeStreamMapId
      }

      // Remove id field from education items with temp- prefix
      if (payload?.education && Array.isArray(payload.education)) {
        payload.education = payload.education.map(edu => {
          if (edu.id && edu.id.startsWith('temp-')) {
            const { id, ...rest } = edu
            return rest
          }
          return edu
        })
      }

      if (tenth && checkMandatory(twelth, diploma)) {
        let response = await updateStudentData(payload)

        const data = response?.response?.data

        if (
          data?.student?.currentState != 4 &&
          data?.student?.educationProfile?.length > 0 &&
          (data?.isAnywhere || data?.preferredJobLocation?.length > 0)
        ) {
          await dispatch(updateCurrentState(data?.student?.id, 4))
        }
        // {if student currentState != 4 && student Education length > 0 && (isAnywhere || stdeunt prefLocation Length > 0)}
        setUpdated(true)
        if (response?.success === true) {
          if (educationDeleteList?.length > 0) {
            educationDeleteList.map(async item => {
              await deleteEducation(item)
            })
          }
          SuccessMessage('Education details saved successfully!')
          await dispatch(setResumeData(payload))

          dispatch(getStudentDataById(studentId)).catch(err => console.error('getStudentDataById error:', err))
          getPendingData().catch(err => console.error('getPendingData error:', err))

          setdrawerStatus(false)
          setSubmitLoading(false)
        } else {
          setSubmitLoading(false)
          ErrorMessage(response?.response?.data?.message)
        }
      } else if (!tenth && checkMandatory(twelth, diploma)) {
        setSubmitLoading(false)
        ErrorMessage('10th is Mandatory')
      } else if (tenth && !checkMandatory(twelth, diploma)) {
        setSubmitLoading(false)
        ErrorMessage('12th or Diploma is Mandatory')
      } else if (!tenth && !checkMandatory(twelth, diploma)) {
        setSubmitLoading(false)
        ErrorMessage('10th  And 12th  or Diploma is Mandatory')
      }
    } else {
      const errorForms = []
      errorList.map(item => {
        item.map(innerItem => {
          if (!errorForms.includes(innerItem?.name[0][0])) {
            errorForms.push(innerItem?.name[0][0])
          }
        })
      })
      const updatedValues = {}
      Object.keys(values).forEach(key => {
        if (errorForms.includes(key)) {
          updatedValues[key] = {
            ...values[key],
            shown: true,
          }
        } else {
          updatedValues[key] = {
            ...values[key],
          }
        }
      })

      form.setFieldsValue(updatedValues)
      setShown(errorForms)
      setSubmitLoading(false)
    }
  }

  const checkMandatory = (twelth, diploma) => {
    return twelth === true || diploma === true
  }
  const content = () => {
    return (
      <>
        {!loading && !skillLoading && (
          <Form
            scrollToFirstError
            htmlType="submit"
            onFinish={submitHandler && !updated}
            id={'educationForm'}
            form={form}
            layout="vertical"
          >
            {education.length
              ? education.map((type, index) => {
                const eduId = type?.id
                const frozenFields = eduId ? frozenFieldsMap[eduId] || {} : {}

                // Get pending fields from educationList
                const educationItem = educationList.find(e => e.id === eduId)
                const pendingFields = educationItem?._pendingFields || {}
                const isNew = educationItem?._isNew || false

                return (
                  // eslint-disable-next-line react/jsx-key
                  <type.component
                    form={form}
                    key={index + 'type'}
                    level={type?.level}
                    label={type?.label}
                    isType={type?.type}
                    universitySearchList={universitySearchList}
                    setUniversitySearchList={setUniversitySearchList}
                    onRemoveEducation={onRemoveEducation}
                    isCurrentCourse={type?.isCurrentCourse}
                    studentFormData={studentFormData}
                    getEducationLevel={getEducationLevel}
                    educationId={type?.id}
                    initialMarkSheetUrl={type?.markSheetUrl}
                    frozenFields={frozenFields}
                    pendingFields={pendingFields}
                    isNew={isNew}
                    countryId={countryId}
                    setCountryId={setCountryId}
                    countryList={countryList}
                    setUniversityName={setUniversityName}
                    universityValue={universityName}
                    universityList={universityList}
                    stateList={stateList}
                    setStateId={setStateId}
                    stateId={stateId}
                    cityId={cityId}
                    setCityId={setCityId}
                    setLocationData={setLocationData}
                    locationData={locationData}
                    getListOfCountries={getListOfCountries}
                    getListOfState={getListOfState}
                    getListOfCity={getListOfCity}
                    examType={examType}
                    duration={duration}
                    setExamType={setExamType}
                    setDuration={setDuration}
                    listOfStudentSkills={listOfStudentSkills}
                    instituteCampusValue={instituteCampusName}
                    setInstituteCampusName={setInstituteCampusName}
                    AllCollegeList={AllCollegeList}
                    CollegeList={CollegeList}
                    universityId={universityId}
                    setUniversityId={setUniversityId}
                    setInstituteId={setInstituteId}
                    insttituteId={instituteId}
                    getListOfSkills={getListOfSkills}
                    setCurrentInstituteName={setCurrentInstituteName}
                    setCurrentInstituteId={setCurrentInstituteId}
                    currentInstituteId={currentInstituteId}
                    currentInstituteName={currentInstituteName}
                    setSearchCollege={setSearchCollege}
                    searchCollege={searchCollege}
                    setIsUpdateButtonEnabled={setIsUpdateButtonEnabled}
                    setLoadingState={setLoadingState}
                    setLoadingCity={setLoadingCity}
                    loadingCity={loadingCity}
                    loadingState={loadingState}
                    getEducationLevelSearch={getEducationLevelSearch}
                    skillLoading={skillLoading}
                    setSkillLoading={setSkillLoading}
                    setListOfSkills={setListOfSkills}
                    listOfSkills={listOfSkills}
                    SkillsAPI={SkillsAPI}
                    shown={shown}
                    searchAPI={searchAPI}
                    allSkills={allSkills}
                  />
                )
              })
              : null}
            {skillLoading && <Spin />}
            <LocalDiv>
              <Control alignCenter gap="10px">
                <AdjustIcon>
                  <AddIcon />
                </AdjustIcon>
                <Text>
                  {education?.some(item =>
                    (item?.level === 'twelfth' || item?.level === 'diploma' || item?.level === 'diploma_0')
                  )
                    ? "Add Education"
                    : "12th or Diploma *"}
                </Text>
              </Control>
            </LocalDiv>

            <SelectLocalWrapper
              key={refreshKey}
              getPopupContainer={() =>
                document.getElementById(
                  'select'
                )
              }
              onChange={(e, option) => !isAddNewFrozen && subjectHandler(e, option)}
              disabled={isAddNewFrozen}
              style={{
                opacity: isAddNewFrozen ? 0.5 : 1,
                cursor: isAddNewFrozen ? 'not-allowed' : 'pointer'
              }}
            >
              {education?.some(item =>
                (item?.level === 'twelfth' || item?.level === 'diploma' || item?.level === 'diploma_0')
              )
                ? educationDetails?.map((data, index) => {
                  let valueData = getEducationLevelValue(data?.value, false, [])
                  return (
                    <Option
                      value={valueData}
                      key={index + 'data'}
                      label={getEducationLevelLabel(data?.value)}
                    >
                      <OptionWrapper alignCenter isAdded={getAddedLevel(valueData)}>
                        {data?.label}
                      </OptionWrapper>
                    </Option>
                  )
                })
                : educationDetailsBefore?.map((data, index) => {
                  let valueData = getEducationLevelValue(data?.value, false, [])
                  return (
                    <Option
                      value={valueData}
                      key={index + 'data'}
                      label={getEducationLevelLabel(data?.value)}
                    >
                      <OptionWrapper alignCenter isAdded={getAddedLevel(valueData)}>
                        {data?.label}
                      </OptionWrapper>
                    </Option>
                  )
                })
              }
            </SelectLocalWrapper>
          </Form>
        )}
        {skillLoading && <Spin />}
      </>
    )
  }

  const footer = () => {
    return (
      <FooterFlex right>
        <Button.Secondary
          text="Cancel"
          onClick={() => {
            setdrawerStatus(false)
            setSubmitLoading(false)
          }}
        />
        <Button.Primary
          onClick={async () => {
            try {
              await form.validateFields()
              if (!hasPendingEducation) {
                submitHandler()
              } else {
                setShowUpdatePopup(true)
              }
            } catch (err) {
            }
          }}
          text={'Update'}
          disabled={submitLoading}
        />
      </FooterFlex>
    )
  }

  return (
    <>
      <UpdatePopup
        form={'educationForm'}
        htmlType="submit"
        open={showUpdatePopup}
        loading={submitLoading}
        onCancel={() => setShowUpdatePopup(false)}
        onConfirm={() => {
          setShowUpdatePopup(false)
          setSuccessPopup(true)
          submitHandler()
        }}
      />
      <SuccessPopupModal
        open={succesPopup}
        onClose={() => setSuccessPopup(false)}
      />

      <StyledDrawer
        width="675px"
        title={'Educational Details'}
        placement="right"
        closable={true}
        onClose={() => {
          setdrawerStatus(false)
          setSubmitLoading(false)
        }}
        visible={drawerStatus}
        content={content()}
        footer={footer()}
      />
    </>
  )
}

export default EducationalDetailDrawer
